import { ApplicationController } from "../../application_controller"

export default class extends ApplicationController {
	create(container_element) {
		$(container_element).find('input[type="text"], input[type="email"], input[type="tel"], input[type="url"]').not('.no-stretchy').addClass('stretchy')
		Stretchy.resizeAll()
	}
}
